/* import __COLOCATED_TEMPLATE__ from './info.hbs.js'; */
import Component from '@glimmer/component';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
export default class DebugInfo extends Component {
  get selectionStyle() {
    let borderWidth = 1;
    return sanitizeHtml(`pointer-events: none;
      position: fixed;
      border: ${borderWidth}px solid green;
      top: ${this.args.composer.state.selectionInfo.rect.top - borderWidth}px;
      left: ${this.args.composer.state.selectionInfo.rect.left - borderWidth}px;
      width: ${this.args.composer.state.selectionInfo.rect.width}px;
      height: ${this.args.composer.state.selectionInfo.rect.height}px;`);
  }
  get insertionPointStyle() {
    if (this.args.composer.state.hoverInfo?.nearestInsertionPoint?.rect) {
      return sanitizeHtml(`pointer-events: none;
        position: fixed;
        height: 1px;
        background: blue;
        top: ${this.args.composer.state.hoverInfo.nearestInsertionPoint.rect.top}px;
        left: ${this.args.composer.state.hoverInfo.nearestInsertionPoint.rect.left}px;
        width: ${this.args.composer.state.hoverInfo.nearestInsertionPoint.rect.width}px;
        height: ${this.args.composer.state.hoverInfo.nearestInsertionPoint.rect.height}px;`);
    } else {
      return sanitizeHtml('display: none;');
    }
  }
  get editorRectStyle() {
    if (this.args.composer.state.hoverInfo?.editorRect) {
      let borderWidth = 1;
      return sanitizeHtml(`pointer-events: none;
      position: fixed;
      border: ${borderWidth}px solid red;
      top: ${this.args.composer.state.hoverInfo.editorRect.top - borderWidth}px;
      left: ${this.args.composer.state.hoverInfo.editorRect.left - borderWidth}px;
      width: ${this.args.composer.state.hoverInfo.editorRect.width}px;
      height: ${this.args.composer.state.hoverInfo.editorRect.height}px;`);
    } else {
      return sanitizeHtml('display: none;');
    }
  }
  get coordPointStyle() {
    if (this.args.composer.state.hoverInfo?.clientCoords) {
      return sanitizeHtml(`pointer-events: none;
        position: fixed;
        top: ${this.args.composer.state.hoverInfo?.clientCoords.y}px;
        left: ${this.args.composer.state.hoverInfo?.clientCoords.x}px;`);
    } else {
      return sanitizeHtml('display: none;');
    }
  }
}